import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/command_on.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class CommandOn extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 200 200' />
  }
}
